import React from 'react'
import CountableNew from './CountableNew'
import { Getintouch } from '../Home/Getintouch'
import ClientLogo from '../Home/ClientLogo'

function EsportsServices() {
  const logos = [
    {
      url: "https://everymatrix.com/clients/bet-at-home/",
      img: "https://everymatrix.com/wp-content/uploads/2021/07/Frame.svg",
      alt: "bet-at-home",
    },
    {
      url: "https://everymatrix.com/clients/tipico/",
      img: "https://everymatrix.com/wp-content/uploads/2019/03/tipico-1.svg",
      alt: "Tipico",
    },
    {
      url: "https://everymatrix.com/clients/opap/",
      img: "https://everymatrix.com/wp-content/uploads/2020/08/pngegg-1.png",
      alt: "OPAP",
    },
    {
      url: "https://everymatrix.com/clients/norsk-tipping/",
      img: "https://everymatrix.com/wp-content/uploads/2019/03/Frame-2.svg",
      alt: "Norsk Tipping",
    },
    {
      url: "https://everymatrix.com/clients/szerencsejatek-zrt/",
      img: "https://everymatrix.com/wp-content/uploads/2023/01/szerencsejatek.svg",
      alt: "Szerencsejáték ZRT",
    },
    {
      url: "https://everymatrix.com/clients/veikkaus/",
      img: "https://everymatrix.com/wp-content/uploads/2022/10/veikkaus-logo.png",
      alt: "Veikkaus",
    },
    {
      url: "https://everymatrix.com/clients/pinnacle/",
      img: "https://everymatrix.com/wp-content/uploads/2024/10/image-60.png",
      alt: "Pinnacle",
    },
    {
      url: "https://everymatrix.com/clients/intralot/",
      img: "https://everymatrix.com/wp-content/uploads/2022/09/Frame-36.svg",
      alt: "Intralot",
    },
    {
      url: "https://everymatrix.com/clients/flutter-entertainment/",
      img: "https://everymatrix.com/wp-content/uploads/2019/12/Group-3.svg",
      alt: "Flutter Entertainment",
    },
    {
      url: "https://everymatrix.com/clients/betparx/",
      img: "https://everymatrix.com/wp-content/uploads/2023/10/betparx.svg",
      alt: "betPARX",
    },
    {
      url: null,
      img: "https://everymatrix.com/wp-content/uploads/2024/11/BetGoodwinLogoNew-2-1-3.png",
      alt: "Private: betgoodwin",
    },
    {
      url: "https://everymatrix.com/clients/malta-national-lottery/",
      img: "https://everymatrix.com/wp-content/uploads/2022/07/national-lottery.svg",
      alt: "Malta National Lottery",
    },
  ];
  return (
    <>
      <nav className="product-submenu blue_nav">
        <ul>
          <li>
            <a href="/fantasy-betting">Overview</a>
          </li>
          <li >
            <a href="/fantasy-betting/sportsbook">Sportsbook</a>
          </li>
          <li>
            <a href="/fantasy-betting/omnichannel/">Omnichannel</a>
          </li>
          <li className='active'>
            <a href="/fantasy-betting/esports-services/">Esports Services</a>
          </li>
          <li>
            <a href="/" target="_blank">Data Feeds</a>
          </li>
        </ul>
      </nav>

      <section className="simple-intro om-simple-intro">
        <div className="container">
          <div className="row g-ma-5 g-4 align-items-center justify-content-between">
            <div className="col-xl-5 col-lg-6">
              <h1 className="section-title heading_left">Esports Betting Services </h1>
              <div className="description"><p>Introducing action-packed titles such as FIFA, NBA2k, CS:GO, DOTA2, the OddsMatrix Esports Services offers the best esports betting coverage in the industry.</p>
              </div>
              <div className="btns pt-5">
                <a href="https://everymatrix.com/contact/" className="btn btn_blue">Contact us</a>
              </div>
            </div>
            <div className='col-md-6'>
              <div className="position-relative">
                <img className='w-100' src="https://everymatrix.com/wp-content/uploads/2021/03/Esports-hero-player.png" />
              </div>
            </div>

          </div>
        </div>
        <a href="#explore" className="explore"></a>
      </section>

      <CountableNew />

      <section className="betting-revolution box-full sec-padd">
        <div className="container">
          <div className="row">
            <div className="col box">
              <div className="inner">
                <div className="inner-content">
                  <div className="row d-flex align-items-center">
                    <div className="col-lg-5">
                      <h3 className="section-title heading_left">Get everything you need </h3>
                      <div className="description">
                        <p>The OddsMatrix Esports Services is delivered as a feed solution or as a hosted solution with a dedicated front-end tailored for esports.</p>
                        <ul>
                          <li>New esports and betting markets added on an ongoing basis</li>
                          <li>Real-time esports betting odds, stats, scores, and settlements</li>
                          <li>Multiple partners for video streaming</li>
                          <li>Fully automated trading</li>
                          <li>Options to tweak odds and customise profit margin</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-7 ml-auto d-flex align-items-center">
                      <div className="ratio ratio-16x9">
                        <video className="w-100" muted controls={false} loop={true} autoPlay={true}>
                          <source src="https://everymatrix.com/wp-content/uploads/2021/03/OM-esports-img2-small-1.mp4" type="video/mp4" />

                        </video>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="esports-hosted-solution bg-light box-full sec-padd">
        <div className="container">
          <div className="row">
            <div className="col box">
              <div className="inner">
                <div className="inner-content">
                  <div className="row d-flex align-items-center justify-content-between">
                    <div className="col-lg-5">
                      <h3 className="section-title heading_left">Esports Hosted Solution</h3>
                      <div className="description">
                        <p>Solution delivered as a bespoke esports tab, easily integrated with your custom front-end, website or mobile betting application.</p>
                        <ul>
                          <li>Short integration time (1-2 weeks) to quickly reach your players</li>
                          <li>Seamlessly integrated with your wallet and player session handling</li>
                          <li>Support for all languages</li>
                          <li>Bonus system for your esports tab</li>
                          <li>Video streams on both match and overview pages</li>
                          <li>Team and tournament logos</li>
                          <li>Scoreboard designed for esports</li>
                          <li>Massive selection of dedicated markets</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-6 ml-auto d-flex align-items-center">
                      <img src="https://everymatrix.com/wp-content/uploads/2024/11/esports-services.jpeg" alt="Esports Hosted Solution" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="data-feeds box-full m-t-50 m-b-50">
        <div className="container">
          <div className="row">
            <div className="col box">
              <div className="inner">
                <div className="inner-content">
                  <div className="row d-flex align-items-center justify-content-between">
                    <div className="col-lg-5">
                      <h3 className="section-title heading_left">Real-time Esports Data Feeds</h3>
                      <div className="description">
                        <p>The OddsMatrix Data Feeds provide real-time coverage of all leading game titles and tournaments.</p>
                        <ul>
                          <li>Events, odds, scores and settlement data</li>
                          <li>Video streams links</li>
                          <li>Massive selection of esports dedicated markets</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-6 ml-auto d-flex align-items-center">
                      <img src="https://everymatrix.com/wp-content/uploads/2021/03/Frame-117-1.png" alt="Real-time Esports Data Feeds" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="product-clients sec-padd grayp">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className='col-md-8 mx-auto'>
                <h2 className="section-title">All the games you love and a growing offering of esports betting markets
                </h2>
                <p>
                  OddsMatrix Esports includes both games familiar to the regular sports player, such as FIFA and NBA2k, and the dedicated games for the computer game enthusiast, such as Counter Strike or DOTA.


                </p>
              </div>
              <ul className="list-clients row">
                {logos.map((logo, index) => (
                  <ClientLogo logo={logo} key={index} />


                ))}
              </ul>
              <div className="text-center">
                <a
                  className="btn btn_blue"
                >
                  View more clients
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <Getintouch />

    </>
  )
}

export default EsportsServices